import type { UserIdentityMetadataResource } from "../authentication";
import type { Client } from "../client";
import type { UserAuthenticationResource } from "../resources/userAuthenticationResource";

export class UserIdentityMetadataRepository {
    private client: Client;
    constructor(client: Client) {
        this.client = client;
    }
    all(): Promise<UserIdentityMetadataResource> {
        return this.client.get(this.client.getLink("UserIdentityMetadata"));
    }
    authenticationConfiguration(userId: string | null) {
        return this.client.get<UserAuthenticationResource>(this.client.getLink("UserAuthentication"), { userId });
    }
}
